import clsx from "clsx";
import React from "react";
import styles from "./styles/SelectField.module.css";
import { Image } from "react-bootstrap";

const SelectField = ({
  name,
  value,
  onChange,
  listValue,
  isLoading = true,
  placeholder,
  error,
  setFieldError,
  touched,
  setFieldTouched,
  isCate = false,
  multiple = false,
  bold = true,
  prefixItem = false,
}) => {
  const handleAdd = (valueMap) => {
    if (multiple === false) {
      onChange(valueMap.id);
    } else {
      if (value.includes(valueMap.id)) {
        onChange(
          value.filter((item) => {
            return item !== valueMap.id;
          })
        );
      } else {
        onChange([...value, valueMap.id]);
      }
    }
  };

  const ListCategoryDropdown = (listCategory) => {
    return listCategory.map((valueMap) => {
      return (
        <div key={`key ${valueMap.id}`}>
          <div className={clsx(styles.dropdownCategoryContainer)}>
            <div className={clsx(styles.verticalLine)}></div>
            <button
              className={`dropdown-item text-dark font-weight-bold ${styles.dropdownCategoryItem}`}
              key={"key category " + valueMap.id}
              disabled
            >
              <span>{valueMap.name}</span>
            </button>
            <div className={clsx(styles.verticalLine)}></div>
          </div>
          {ListDropdown(valueMap.subCategories)}
        </div>
      );
    });
  };

  const ListDropdown = (listItem) => {
    return listItem.map((valueMap) => {
      return (
        <button
          type="button"
          className={`dropdown-item ${styles.dropdownItem}`}
          value={valueMap.id}
          key={"key item " + valueMap.id}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleAdd(valueMap);
            }
          }}
          onMouseDown={() => {
            handleAdd(valueMap);
          }}
        >
          {prefixItem === true ? (
            <Image
              className="flag-img pr-2"
              src={`https://flagicons.lipis.dev/flags/4x3/${valueMap.code}.svg`}
              alt={`Flag of ${valueMap.name}`}
              width={30}
              height={30}
            />
          ) : null}

          {!multiple ? (
            !isCate ? (
              value === valueMap.id ? (
                <b>{valueMap.name}</b>
              ) : (
                valueMap.name
              )
            ) : value === valueMap.id ? (
              <b>{valueMap.name}</b>
            ) : (
              valueMap.name
            )
          ) : value.includes(valueMap.id) ? (
            <b>{valueMap.name}</b>
          ) : (
            valueMap.name
          )}
        </button>
      );
    });
  };

  return (
    <>
      <div className={clsx(styles.selectContainer)}>
        <div className={clsx(styles.formContainer)}>
          <div className={"dropdown"}>
            <button
              name={name}
              className={clsx(
                "btn btn-secondary d-flex flex-row align-items-center justify-content-between dropdown-toggle w-100 pl-4",
                styles.dropdownField,
                {
                  [styles.placeHolder]: !value,
                  [styles.dropdownError]: touched && error,
                  // "bi bi-exclamation-triangle text-danger": touched && error,
                }
              )}
              type="button"
              id="dropdownMenu"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              onBlur={() => {
                setFieldError();
                setFieldTouched();
              }}
            >
              <span className={clsx("text-truncate")}>
                {!value || value.length === 0 ? (
                  placeholder
                ) : multiple ? (
                  // <div className={clsx(styles.multipleChoice)}>
                  <span style={{ fontWeight: "500" }}>
                    {value
                      .map((val) => {
                        if (
                          listValue
                            .map((subVal) => {
                              return subVal.id;
                            })
                            .includes(val)
                        ) {
                          return listValue
                            .filter((subVal) => {
                              return subVal.id === val;
                            })
                            .map((subVal) => {
                              return subVal.name;
                            });
                        } else {
                          return 0;
                        }
                      })
                      .reverse()
                      .join(", ")}
                    {/* {value
                      .map((val) => {
                        if (
                          listValue
                            .map((subVal) => {
                              return subVal.id;
                            })
                            .includes(val)
                        ) {
                          return listValue
                            .filter((subVal) => {
                              return subVal.id === val;
                            })
                            .map((subVal) => {
                              return subVal.name;
                            });
                        } else {
                          return 0;
                        }
                      })
                      .reverse()
                      .map((value, key) => {
                        return (
                          <div
                            key={"key " + key}
                            className={clsx(styles.choice)}
                          >
                            <span>{value}</span>
                            <i
                              className={clsx("bi bi-x", styles.iconDelete)}
                              onClick={() => {
                                console.log(123);
                              }}
                            />
                          </div>
                        );
                      })} */}
                  </span>
                ) : (
                  <span
                    className={clsx({ ["font-weight-bold"]: bold === true })}
                  >
                    {prefixItem === true ? (
                      <Image
                        className="flag-img pr-2"
                        src={`https://flagicons.lipis.dev/flags/4x3/${
                          listValue.filter((subVal) => subVal.id === value)[0]
                            .code
                        }.svg`}
                        alt={`Flag of ${
                          listValue.filter((subVal) => subVal.id === value)[0]
                            .name
                        }`}
                        width={30}
                        height={30}
                      />
                    ) : null}
                    {!isCate
                      ? listValue.filter((subVal) => subVal.id === value)[0]
                          .name
                      : listValue.map((val) => {
                          if (
                            val.subCategories.filter((subVal) => {
                              return subVal.id === value;
                            }).length > 0
                          ) {
                            return val.subCategories.filter((subVal) => {
                              return subVal.id === value;
                            })[0].name;
                          }
                        })}
                  </span>
                )}
              </span>
            </button>
            <div
              className={`dropdown-menu w-100 ${styles.dropdownMenu}`}
              aria-labelledby="dropdownMenu"
            >
              {!listValue || listValue.length !== 0 ? (
                isLoading ? (
                  <div className="px-4">Categories are being loaded...</div>
                ) : isCate ? (
                  ListCategoryDropdown(listValue)
                ) : (
                  ListDropdown(listValue)
                )
              ) : (
                <div className="px-4">Nothing in here</div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <Form.Control
        name={name}
        type={"text"}
        value={value}
        readOnly
        style={{ display: "none" }}
      ></Form.Control> */}
      <div className={clsx(styles.errorText, "text-left")}>
        {touched && error}
      </div>
    </>
  );
};

/* required: display name */
SelectField.displayName = "SelectField";

/* required: props types */
SelectField.propTypes = {};

/* required: default props */
SelectField.defaultProps = {};

export { SelectField };
